import React, { Component } from 'react'
import {
	printShipmentInvoice,
	notifySapiAboutPrint
} from './../common/invoiceService'
import { TextField, Snackbar } from '@cimpress/react-components'
import Spinner from '@cimpress/react-components/lib/shapes/Spinner'
import { getQzConfig } from '../config'
import { getErrorMessage } from '../common/ErrorForTranslation'
import { getTranslate } from 'react-localize-redux/lib/index'
import { connect } from 'react-redux'
import autobind from 'react-autobind'

class Print extends Component {
	constructor(props) {
		super(props)
		this.state = {
			notification: <Snackbar show={false} />,
			isSpinnerOn: false,
			shipmentId: ''
		}
		autobind(this)
	}

	onShipmentIdChange({target: {value: shipmentId}}) {
		this.setState({shipmentId})
	}

	async onKey({key, type}) {
		if (key !== 'Enter') {
			return
		}

		const {shipmentId} = this.state
		this.setState({isSpinnerOn: true})
		try {
			const {id} = await printShipmentInvoice(
				shipmentId,
				getQzConfig().shipmentLocation,
				getQzConfig().printerName,
				getQzConfig().ciDocumentType)
			await notifySapiAboutPrint(id)
			this.setState({
				notification: (
					<Snackbar show={true} delay={3000}>
						Commercial invoice has been printed for {shipmentId}.
					</Snackbar>
				)
			})
		} catch (error) {
			this.setState({
				notification: (
					<Snackbar show={true} delay={3000} bsStyle={'danger'}>
						{getErrorMessage(error, this.props.translate)}
					</Snackbar>
				)
			})
		}
		this.setState({isSpinnerOn: false, shipmentId: ''})
	}

	render() {
		return (
			<div className="container">
				<div className="row">
					<div className="col-md-12">
						<h3>Print Invoice</h3>
						{this.state.notification}
						{this.state.isSpinnerOn && (
							<div>
								Printing the commercial invoice for {this.state.shipmentId}.
								<Spinner size={48} className="text-center" />
							</div>
						)}
						{!this.state.isSpinnerOn && (
							<TextField
								name="shipmentId"
								value={this.state.shipmentId}
								label="Shipment ID"
								onChange={this.onShipmentIdChange}
								onKeyDown={this.onKey}
								autoFocus
							/>
						)}
					</div>
				</div>
			</div>
		)
	}
}

export default connect(state => ({
	translate: getTranslate(state.locale)
}))(Print)



// WEBPACK FOOTER //
// ./src/components/Print.js